import { Component, Input } from '@angular/core';
import { subscriptionShopUrl } from '../mock-subscription';

@Component({
  selector: 'app-mock-subscription',
  templateUrl: './mock-subscription.component.html',
  styleUrls: ['./mock-subscription.component.scss']
})
export class MockSubscriptionComponent {
  @Input() keepAnswers = false;

  shopUrl(): string {
    return subscriptionShopUrl(localStorage.getItem('language'));
  }
}
